import ResponsiveHelper from "../utils/ResponsiveHelper";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import Filter from "../components/Filter";

export default class PageProgrammes {
  constructor(dom) {
    this.dom = dom;

    window.addEventListener("resize", () => this.resize());

    if (this.dom.querySelector('.filterMain')) {
      let filter = new Filter(this.dom.querySelector('.filterMain'));
      filter.init();
    }
  }

  async init() {
    this.initResponsiveHelper();

    let _this = this

    // ScrollTrigger.matchMedia({
    //   "(min-width: 769px)": function () {
    //     // console.log('d');
    //     ScrollTrigger.create({
    //       trigger: _this.dom.querySelector('.filter'),
    //       start: "top 115px",
    //       end: () => {
    //         let h = _this.dom.querySelector('.listing').offsetHeight - _this.dom.querySelector('.filter').offsetHeight
    //         console.log(h);
    //         return `+=${h}`
    //       },
    //       pin: true,
    //       // markers: true,
    //     });
    //   },
    //   "(max-width: 768px)": function () {
    //
    //   },
    // })
  }



  initResponsiveHelper() {

  }

  resize() {
  }

  destory() {

  }
}
